import { DownloadItemType } from "../../types/DownloadItemType";
import { getRequestWrapper } from "../../utilities";

type getBetaByAppIdParams = {
  store_id: string | number;
};

// Response ----------

export type getBetasByAppIdResponse = { body: DownloadItemType[] };

// Request ----------

export function getBetasByAppId(
  id: string,
  params?: getBetaByAppIdParams
): Promise<getBetasByAppIdResponse> {
  return getRequestWrapper<getBetaByAppIdParams, getBetasByAppIdResponse>({
    url: `${ENV_SETTINGS.API_URL}/apps/${id}/betas`,
    params,
  });
}
